export default {
  id: 231,
  title: 'Target #231 - Crosshair',
  url: 'https://cssbattle.dev/play/231',
  colors: ['#2F434E', '#CF6939', '#F8B140'],
  solution:
    '<p a><p b><style>body{background:#2f434e}p{position:fixed;margin:0}p[a]{top:35;left:160;width:80;height:80;background:#f8b140;border-radius:1in;box-shadow:-75px 75px #f8b140,75px 75px #f8b140,0 150px #f8b140}p[b]{top:95;left:145;width:110;height:110;background:radial-gradient(circle,#cf6939 40px,#2f434e 40px);box-shadow:-85px -85px #2f434e,85px -85px #2f434e,85px 85px #2f434e,-85px 85px #2f434e',
}
